import { Icon, SvgIcon, Text } from '@bridebook/aura';
import { memo, PropsWithChildren, SyntheticEvent } from 'react';

type Props = {
  icon: SvgIcon;
  onClick?: (event: SyntheticEvent) => void;
};

const MediaButtonComponent = ({ icon, children, onClick }: PropsWithChildren<Props>) => (
  <button
    className="flex flex-row items-center gap-1 rounded-sm bg-[rgba(0,0,0,0.6)] px-2 py-1 text-left hover:bg-[rgba(0,0,0,0.4)] focus-visible:ring-focus-ring focus-visible:ring-offset-2 focus-visible:outline-none lg:rounded-lg lg:px-3 lg:py-2"
    onClick={onClick}>
    <Icon icon={icon} className="flex-none text-white" size={16} />
    <Text className="typo-sm text-white">{children}</Text>
  </button>
);

export const MediaButton = memo(MediaButtonComponent);
